import Lookup from 'src/componentes/select2';

const Aging = (props) => {
  return (
    <Lookup labelKey="descricao" valueKey="id" url="/AgingLookup" {...props} />
  );
};

export default Aging;
